import { EProductKind, IMenuTileProps } from '@orderingstack/ordering-types';
import { getMediaOrFallback } from '../../utils';
// @ts-ignore
import { useDisplayPrice, getMediaUrl } from '@orderingstack/front-hooks';
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { formatPrice } from '../../utils';

export function ProductTile({
  product,
  onProductClicked,
  fallbackImg,
  currency,
  lazyLoadImg,
}: IMenuTileProps) {
  const { displayPrice } = useDisplayPrice({ product });
  const targetProductId = product.details?.literals?.['target-product-id'];

  function productClicked() {
    if (product.kind === EProductKind.PRODUCT) {
      return onProductClicked(product);
    }
    if (product.kind === EProductKind.STATIC) {
      if (targetProductId) {
        return onProductClicked(targetProductId);
      } else {
        throw new Error("'target-product-id' is required but is missing'");
      }
    }
  }

  if (product.kind === EProductKind.STATIC) {
    // Return banner - all columns span
    return (
      <div
        className={`col-span-full ${targetProductId ? 'cursor-pointer' : ''}`}
        onClick={productClicked}
        id={`product-${product.id}`}
      >
        <LazyLoadImage
          visibleByDefault={!lazyLoadImg}
          alt="product_img"
          className="object-contain w-full h-full"
          src={getMediaUrl(getMediaOrFallback(product, fallbackImg), 160)}
        />
      </div>
    );
  }

  return (
    <>
      <div
        className="aspect-auto flex relative flex-col justify-between items-center text-[3vw] text-center rounded-2xl border border-[color:var(--product-tile-border-color)] cursor-pointer lg:text-2xl"
        onClick={productClicked}
        id={`product-${product.id}`}
      >
        <div className="flex flex-col justify-between px-2 w-full h-full text-menuProductName">
          <LazyLoadImage
            visibleByDefault={!lazyLoadImg}
            alt="product_img"
            className="object-contain h-[160px]"
            src={getMediaUrl(getMediaOrFallback(product, fallbackImg), 160)}
          />
          <div className="flex flex-col grow justify-start w-full">
            <div className="break-words">{product.details?.literals?.name}</div>
            {!isNaN(displayPrice) && (
              <div className="font-price">
                {formatPrice(displayPrice, currency)}
              </div>
            )}
          </div>
        </div>
        {product?.outsideAvailabilitySlot && (
          <>
            <div className="flex absolute flex-col justify-center w-full h-full bg-gray-300 rounded-2xl opacity-40" />
          </>
        )}
      </div>
    </>
  );
}
